// @flow

import React from 'react';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import type { ReconciliationStore } from '../../../../types/shoppingCenterType';
import { reconciliationStates } from '../../../../const';
import { roundValue } from '../../../../utils/formatUtils';
import SearchSelectStore from '../gemini/SearchSelectStore';

type Props = {
  changeMappingMode: () => void,
  storeList: ReconciliationStore[],
  updateSelectedStore: () => void,
}

type State = {
  search: string,
}

class LeftDataMappingMode extends React.Component<Props, State> {
  state: State = {
    search: '',
  };

  constructor() {
    super();
    this.inputSearch = React.createRef();
    this.clearFilter = this.clearFilter.bind(this);
  }

  clearFilter = () => {
    this.setState({ search: '' });
    this.inputSearch.current.value = '';
  };

  getPourcentage = () => {
    const reconciledStores = this.props.storeList
      .filter(store => store.state === reconciliationStates.MAPPED
          || store.state === reconciliationStates.OK)
      .length;
    const nbTotalMercury = this.props.storeList
      .filter(store => store.idMercury != null
          && (store.closingDate === null || moment(store.closingDate).isSameOrAfter(moment())))
      .length;

    return roundValue((reconciledStores / nbTotalMercury) * 100);
  }

  render() {
    return (
      <div className="left data-mapping-mode">
        <div className="content-data-mapping-mode">
          <div className="header-mapping-mode">
            <button
              className="fa fa-chevron-left return"
              onClick={this.props.changeMappingMode}
            />
            <div className="title-mapping-mode">
              {I18n.t('MAPPING_MODE.title')}
            </div>
          </div>
          <div className="search-bar">
            <SearchSelectStore
              searchWord={this.state.search}
              selectSources={this.props.storeList
                .filter(store => store.idVisioglobes && store.idVisioglobes.length > 0)
                .map(store => ({
                  label: store.mercuryName || store.luxName || 'Empty Unit',
                  id: store.idVisioglobes[0],
                  store,
                }))}
              search={(event: EventHandler) => {
                this.setState({
                  search: event.target.value,
                });
              }}
              handleChange={this.props.updateSelectedStore}
              resetSearch={() => this.setState({ search: '' })}
              reference={this.inputSearch}
              selectStoreCat={() => ''}
              displayVisioglobeIds
            />
          </div>
          <div className="jauge-mapping-mode">
            <div className="jauge-title">
              <span>{I18n.t('MAPPING_MODE.mappingStage')}</span>
              <div className="tooltip-container">
                <i className="fal fa-info-circle tooltip-i" />
                <span className="tooltip-text">{I18n.t('MAPPING_MODE.jauge')}</span>
              </div>
            </div>
            <div className="jauge">
              <div style={{ width: `${(((100 - this.getPourcentage()) * 228) / 100)}px` }} />
            </div>
            <span className="pourcentage" style={{ left: `${((this.getPourcentage() * 228) / 100) - 15}px` }}>
              {I18n.t('MAPPING_MODE.pourcentage', { pourcentage: this.getPourcentage() })}
            </span>
          </div>
          <div className="legend-mapping-mode">
            <div className="legend-content">
              <div className="legend-color multipleLux" />
              <div className="legend-name">
                {
                  I18n.t(
                    'MAPPING_MODE.multipleLux',
                    {
                      number: this.props.storeList.filter(store =>
                        store.state === reconciliationStates.MULTIPLE_LUX).length,
                    },
                  )}
              </div>
            </div>
            <div className="legend-content">
              <div className="legend-color multipleMercury" />
              <div className="legend-name">
                {
                  I18n.t(
                    'MAPPING_MODE.multipleMercury',
                    {
                      number: this.props.storeList.filter(store =>
                        store.state === reconciliationStates.MULTIPLE_MERCURY).length,
                    },
                  )}
              </div>
            </div>
            <div className="legend-content">
              <div className="legend-color emptyUnit" />
              <div className="legend-name">
                {
                  I18n.t(
                    'MAPPING_MODE.emptyUnit',
                    {
                      number: this.props.storeList.filter(store =>
                        store.state === reconciliationStates.EMPTY_UNIT).length,
                    },
                  )}
              </div>
            </div>
            <div className="legend-content">
              <div className="legend-color retailerMissing" />
              <div className="legend-name">
                {
                  I18n.t(
                    'MAPPING_MODE.retailerMissing',
                    {
                      number: this.props.storeList.filter(store =>
                        store.state === reconciliationStates.RETAILER_MISSING).length,
                    },
                  )}
              </div>
            </div>
            <div className="legend-content">
              <div className="legend-color luxOnly" />
              <div className="legend-name">
                {
                  I18n.t(
                    'MAPPING_MODE.luxOnly',
                    {
                      number: this.props.storeList.filter(store =>
                        store.state === reconciliationStates.LUX_ONLY).length,
                    },
                  )}
              </div>
            </div>
            <div className="legend-content">
              <div className="legend-color manuallyFlagged" />
              <div className="legend-name">
                {
                  I18n.t(
                    'MAPPING_MODE.manuallyFlagged',
                    {
                      number: this.props.storeList.filter(store =>
                        store.state === reconciliationStates.FLAGGED).length,
                    },
                  )}
              </div>
            </div>
            <div className="legend-content">
              <div className="legend-color manuallyMapped" />
              <div className="legend-name">
                {
                  I18n.t(
                    'MAPPING_MODE.manualyMapped',
                    {
                      number: this.props.storeList.filter(store =>
                        store.state === reconciliationStates.MAPPED).length,
                    },
                  )}
              </div>
            </div>
          </div>
          <span className="list-mercury-only-title">{I18n.t('MAPPING_MODE.onlyInMercury')}</span>
          <div className="list-mercury-only">
            <div className="store-list-mercury-only">
              {
                this.props.storeList &&
                this.props.storeList.filter(store =>
                  store.state === reconciliationStates.MERCURY_ONLY
                  || store.state === reconciliationStates.MERCURY_OK_UNMAPPED
                  || (store.state === reconciliationStates.MAPPING && store.mercuryName)).length > 0
                && this.props.storeList.filter(store =>
                  store.state === reconciliationStates.MERCURY_ONLY
                  || store.state === reconciliationStates.MERCURY_OK_UNMAPPED
                  || (store.state === reconciliationStates.MAPPING && store.mercuryName))
                  .sort((a, b) => a.mercuryName.localeCompare(b.mercuryName))
                  .map(mercuryOnlyStore => (
                    <div
                      key={mercuryOnlyStore.id}
                      className={`mercury-only-store ${mercuryOnlyStore.idMercury === null ? 'impossible' : ''}`}
                    >
                      {mercuryOnlyStore.mercuryName} [{mercuryOnlyStore.idMercury}]
                      {mercuryOnlyStore.idMercury === null && <span>{I18n.t('MAPPING_MODE.mappingImpossible')}</span>}
                    </div>
                  ))
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LeftDataMappingMode;
